export interface AverageBillingOption {
  value: number;
  label: string;
}

export const AverageBillingOptions: AverageBillingOption[] = [
  {
    value: 1,
    label: 'até 20 mil',
  },
  {
    value: 2,
    label: 'de 21 mil à 50 mil',
  },
  {
    value: 3,
    label: 'de 51 mil à 70 mil',
  },
  {
    value: 4,
    label: 'de 71 mil à 100 mil',
  },
  {
    value: 5,
    label: 'de 101 mil à 400 mil',
  },
  {
    value: 6,
    label: 'de 401 mil à 1 milhão',
  },
  {
    value: 7,
    label: 'mais de 1 milhão',
  },
];
